import React, { useEffect, useState } from 'react';
import { toast } from 'react-hot-toast';

const LiveMatchControl = ({ scorecard, startInning, firstInnings, secondInnings, isStrikerAvaiable, endFirstInning, handleRunOut, currentInning, isRunOut, setIsRunOut, nonStrikerAvaiable, disableButtonFor3Seconds, isCurrentOver, handleWicket, isDisabled, showOutOptions, setShowOutOptions, loading, updateLiveMatchScore, nonStriker, striker, currentBowler, matchId, battingTeamPlayers, bowlingTeamPlayers, handleStrikerChange, updateOverAndBowler, handleNonStrikerChange, addNewBatmans, changeBowler }) => {
    const { match, innings } = scorecard ?? {};
    const [notOutPlayers, setNotOutPlayers] = useState([]);
    const [availableForNonStriker, setAvailableForNonStriker] = useState([]);

    const runningCurrentStatus = (innings?.find(inn => inn.innstatus === "in_progress" || inn.innstatus === "upcoming"));

    useEffect(() => {
        const getAvailablePlayers = () => {
            // Filter out players who are "out"
            const notOutPlayers = battingTeamPlayers.filter(player =>
                !currentInning?.batting?.some(inn =>
                    inn.playerId === player.playerId && inn.how_out !== 'out' // Check if the player is out
                )
            );

            // Exclude the current striker from the non-striker options
            const availableForNonStriker = notOutPlayers.filter(player => player.playerName !== striker?.playerName);

            setNotOutPlayers(notOutPlayers);
            setAvailableForNonStriker(availableForNonStriker);
        };

        getAvailablePlayers();
    }, [battingTeamPlayers, currentInning, striker?.playerName]);

    const handleStrikerChangeEvent = (e) => {
        addNewBatmans(e, "striker");
    };

    const handleNonStrikerChangeEvent = (e) => {
        addNewBatmans(e, "non-striker");
    };

    // if (!scorecard || !match || !innings) return <p>Loading live match...</p>;

    return (
        <>
          {scorecard && match && innings && (
                <div className="live-match-admin">
                    <div className="live-header">
                        <h3>🏏 Live Match Control Panel</h3>
                        <p>Update real-time match data manually</p>
                    </div>

                    <div className="match-summary">
                        <div className="score-box">
                            <h4>{match.teamA_name}</h4>
                            <p className="score">
                                {innings.find(inn => inn.batting_team_id === match.teamA_id)?.total_runs || 0}/
                                {innings.find(inn => inn.batting_team_id === match.teamA_id)?.wickets || 0}
                            </p>
                            <p className="overs">
                                Overs: {(innings.find(inn => inn.batting_team_id === match.teamA_id)?.overs || 0).toFixed(1)} / {match.totalOver}
                            </p>
                        </div>

                        <div className="score-box">
                            <h4>{match.teamB_name}</h4>
                            <p className="score">
                                {innings.find(inn => inn.batting_team_id === match.teamB_id)?.total_runs || "–"}/
                                {innings.find(inn => inn.batting_team_id === match.teamB_id)?.wickets || "–"}
                            </p>
                            <p className="overs">
                                {innings.find(inn => inn.batting_team_id === match.teamB_id)?.overs
                                    ? `Overs: ${(innings.find(inn => inn.batting_team_id === match.teamB_id)?.overs).toFixed(1)} / ${match.totalOver}`
                                    : "Yet to Bat"}
                            </p>
                        </div>
                    </div>

                    {currentInning?.wickets < 10 && (
                        <>
                            <div className="players-section">
                                <div className="player-card striker">
                                    <h5>Striker</h5>
                                    <p>{striker.playerName || "-"} – {striker.runs || 0} ({striker.balls || 0})</p>
                                </div>

                                <div className="player-card non-striker">
                                    <h5>Non-Striker</h5>
                                    <p>{nonStriker.playerName || "-"} – {nonStriker.runs || 0} ({nonStriker.balls || 0})</p>
                                </div>
                            </div>

                            {runningCurrentStatus?.innstatus === "in_progress" && (
                                <>
                                    {currentBowler && (
                                        <div className="players-section">
                                            <div className="player-card current-bowler">
                                                <h5>Current Bowler</h5>
                                                {Object.keys(currentBowler).length > 0 ? (
                                                    <p>{`${currentBowler?.playerName} - ${currentBowler?.overs?.toFixed(1)} (${currentBowler?.runs_conceded}/${currentBowler?.wickets})`}</p>
                                                ) : (
                                                    <p>{`No Bowler`}</p>
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    <div className="openers d-flex gap-4 align-items-center">
                                        <div className="opener-select">
                                            <label>Striker:</label>
                                            <select
                                                value={striker?.playerName || ""}
                                                onChange={handleStrikerChangeEvent}
                                                className="form-select"
                                                disabled={isStrikerAvaiable}
                                            >
                                                <option>
                                                    Select Striker
                                                </option>
                                                {notOutPlayers.map((item, i) => (
                                                    <option key={i} value={item.playerName}>
                                                        {item.playerName} {`(${item?.playerRole})`}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="opener-select">
                                            <label>Non-Striker:</label>
                                            <select
                                                value={nonStriker?.playerName || ""}
                                                onChange={handleNonStrikerChangeEvent}
                                                className="form-select"
                                                disabled={nonStrikerAvaiable}
                                            >
                                                <option>
                                                    Select Non-Striker
                                                </option>
                                                {availableForNonStriker.map((item, i) => (
                                                    <option key={i} value={item.playerName}>
                                                        {item.playerName} {`(${item?.playerRole})`}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="opener-select">
                                            <label>Bowler:</label>
                                            <select
                                                value={currentBowler?.playerId || ""}
                                                onChange={(e) => changeBowler(e.target.value)}  // Pass playerId
                                                className="form-select"
                                                disabled={!!isCurrentOver}
                                            >
                                                <option>
                                                    Select Bowler
                                                </option>
                                                {bowlingTeamPlayers.map((item, i) => (
                                                    <option key={i} value={item.playerId}> 
                                                        {item.playerName} {`(${item?.playerRole})`}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </>
                            )}

                            {match.totalOver > (innings.find(inn => inn.batting_team_id === match.teamA_id)?.overs || 0).toFixed(1) && runningCurrentStatus?.innstatus === "in_progress" && (Object.keys(striker).length > 0 && Object.keys(nonStriker).length > 0) && (
                                < div className="control-panel my-4">
                                    <h5 className='mb-3'>Scoring Controls</h5>
                                    {(secondInnings?.innstatus !== 'completed' || firstInnings?.innstatus !== 'completed') && (
                                        <div className="buttons-grid">
                                            <button onClick={() => {
                                                disableButtonFor3Seconds();
                                                updateLiveMatchScore(0);
                                            }}
                                                disabled={isDisabled}
                                            >0</button>
                                            <button onClick={() => {
                                                disableButtonFor3Seconds();
                                                updateLiveMatchScore(1);
                                            }}
                                                disabled={isDisabled}
                                            >1</button>
                                            <button
                                                onClick={() => {
                                                    disableButtonFor3Seconds();
                                                    updateLiveMatchScore(2);
                                                }}
                                                disabled={isDisabled}
                                            >2</button>
                                            <button
                                                onClick={() => {
                                                    disableButtonFor3Seconds();
                                                    updateLiveMatchScore(3);
                                                }}
                                                disabled={isDisabled}
                                            >3</button>
                                            <button
                                                onClick={() => {
                                                    disableButtonFor3Seconds();
                                                    updateLiveMatchScore(4);
                                                }}
                                                disabled={isDisabled}
                                            >4</button>
                                            <button
                                                onClick={() => {
                                                    disableButtonFor3Seconds();
                                                    updateLiveMatchScore(5);
                                                }}
                                                disabled={isDisabled}
                                            >5</button>
                                            <button
                                                onClick={() => {
                                                    disableButtonFor3Seconds();
                                                    updateLiveMatchScore(6);
                                                }}
                                                disabled={isDisabled}
                                            >6</button>
                                            <button onClick={() => handleWicket()}>Wicket</button>
                                            <button
                                                onClick={() => {
                                                    disableButtonFor3Seconds();
                                                    updateLiveMatchScore(1, false, null, striker.playerId, true, false);
                                                }}
                                                disabled={isDisabled}
                                            >Wide</button>
                                            <button
                                                onClick={() => {
                                                    disableButtonFor3Seconds();
                                                    updateLiveMatchScore(1, false, null, striker.playerId, false, true);
                                                }}
                                                disabled={isDisabled}
                                            >
                                                No Ball
                                            </button>
                                        </div>
                                    )}
                                </div>
                            )}

                            {
                                showOutOptions && (
                                    <div className="buttons-grid">
                                        <button onClick={() => updateLiveMatchScore(0, true, "Caught out!", false, false)}>Caught</button>
                                        <button onClick={() => updateLiveMatchScore(0, true, "Bowled out!!", false, false)} >Bowled</button>
                                        <button onClick={() => updateLiveMatchScore(0, true, "LBW!", false, false)} >LBW</button>
                                        <button onClick={() => updateLiveMatchScore(0, true, "Hit Wicket!", false, false)} >LBW</button>
                                        <button onClick={() => updateLiveMatchScore(0, true, "Stamps!", false, false)} >LBW</button>
                                        <button onClick={() => setIsRunOut(true)}>Run Out</button>
                                    </div>
                                )
                            }

                            {isRunOut && (
                                <>
                                    <div className="players-section">
                                        <div className="player-card striker" onClick={() => updateLiveMatchScore(0, true, "RunOut", striker?.playerId, false, false)}>
                                            <h5>Striker</h5>
                                            <p>{striker.playerName}</p>
                                        </div>

                                        <div className="player-card non-striker" onClick={() => updateLiveMatchScore(0, true, "RunOut", nonStriker?.playerId, false, false)}>
                                            <h5>Non-Striker</h5>
                                            <p>{nonStriker.playerName}</p>
                                        </div>
                                    </div>
                                </>
                            )}

                            <div className="update-section mt-4">
                                {runningCurrentStatus?.inning_no === 1 && runningCurrentStatus?.innstatus === 'upcoming' && (
                                    <button className="btn-end" onClick={() => startInning(1)}>🏁 Start 1st Innings</button>
                                )}

                                {runningCurrentStatus?.inning_no === 1 && runningCurrentStatus?.innstatus === 'in_progress' && runningCurrentStatus?.innstatus !== 'completed' && (
                                    <button className="btn-end" onClick={() => endFirstInning(1)}>🏁 End 1st Innings</button>
                                )}

                                {runningCurrentStatus?.innstatus === 'upcoming' && currentInning?.inning_no !== 2 && (
                                    <button className="btn-end" onClick={() => startInning(2)}>🏁 Start 2nd Innings</button>
                                )}

                                {currentInning?.inning_no === 2 && currentInning?.innstatus === 'in_progress' && currentInning?.innstatus !== 'completed' && (
                                    <button className="btn-end" onClick={() => endFirstInning(2)}>🏁 End 2nd Innings</button>
                                )}
                            </div>
                        </>
                    )}
                </div >
            )} 
        </>
    );
};

export default LiveMatchControl;
